import { computed } from 'vue';
import { useAuthStore } from '@/stores/authStore';

export function useReembolsoAprovadorFlag() {
  const authStore = useAuthStore();
  const ehAprovador = computed(() => authStore.roleFlags.isAprovadorReembolso);
  return { ehAprovador };
}
